"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Tab = function (props) {
    var children = props.children, isActive = props.isActive, _a = props.hasError, hasError = _a === void 0 ? false : _a, _b = props.isChild, isChild = _b === void 0 ? false : _b, identifier = props.identifier, setActiveTab = props.setActiveTab;
    var className = [
        'tabs__tab',
        isActive ? 'tabs__tab--active' : false,
        isChild ? 'tabs__tab--child' : false,
        hasError ? 'tabs__tab--has-error' : false,
    ]
        .filter(Boolean)
        .join(' ');
    return (react_1.default.createElement("button", { type: "button", onClick: function () { return setActiveTab(identifier); }, className: className }, children));
};
exports.default = Tab;
//# sourceMappingURL=Tab.js.map